module.exports = __webpack_public_path__ + "img/img2.d3c999a1.png";